
import { RevCard } from '@ds/components/Card'
import { mapGetters } from 'vuex'

import IllustrationGhost from '@core/illustrations/IllustrationGhost.svg'

import translations from './NoResultsBanner.translations'

export default {
  components: {
    IllustrationGhost,
    RevCard,
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      landingTitle: 'landing/title',
    }),
  },
}
